import api from './api'

export const systemEmailBasePath = '/api/v1/system-email'

export async function createUserGroup(groupName, emailFilters) {
  const resp = await api.post(`${systemEmailBasePath}`, { groupName, emailFilters })
  return resp.data
}

export async function patchUserGroupById(userGroupId, groupName, emailFilters) {
  const resp = await api.patch(`${systemEmailBasePath}/${userGroupId}`, { groupName, emailFilters })
  return resp.data
}

export async function deleteUserGroupById(userGroupId) {
  const resp = await api.delete(`${systemEmailBasePath}/${userGroupId}`)
  return resp.data
}

export async function getAllUserGroup() {
  const resp = await api.get(`${systemEmailBasePath}`)
  return resp.data
}

export async function getUserGroupById(userGroupId) {
  const resp = await api.get(`${systemEmailBasePath}/${userGroupId}`)
  return resp.data
}

export async function getUsersByEmailFilters(emailFilters) {
  const resp = await api.get(`${systemEmailBasePath}/filtered-users`, { params: emailFilters })
  return resp.data
}
